import angular from 'angular';

export const parseGeneratedCodeFormat = format => {
  const elements = [];
  if (!format) return elements;

  let part = '';
  let inBlock = false;
  for (let i = 0; i < format.length; i++) {
    const c = format[i];

    if (!inBlock && c === '[') {
      inBlock = true;

      if (part !== '') {
        elements.push({ id: 'Text', t: part });
        part = '';
      }
    } else if (inBlock && c === ']') {
      inBlock = false;
      part = part.toLowerCase();

      // Only handle Counter format, ignore date formats
      var n = parseInt(part.replace('counter:n', '').trim());
      if (Number.isInteger(n)) {
        elements.push({ id: 'Counter', n: n });
      }

      part = '';
    } else {
      part += c;
    }
  }
  if (part !== '') {
    elements.push({ id: 'Text', t: part });
    part = '';
  }
  return elements;
};

const randomCounter = Math.round(Math.random() * 500);
export const generateGeneratedCodeExample = (input, counter) => {
  if (!input) return null;
  let elements = [];
  //Format as string
  if (typeof input === 'string') elements = parseGeneratedCodeFormat(input);
  //Format as array of elements
  else if (typeof input === 'object' && input.length) elements = input;
  else return null;

  const exampleCounter = parseInt(counter) || randomCounter;

  return elements.reduce(function(result, el) {
    if (el.id === 'Text') return result + el.t;
    if (el.id === 'Counter') return result + ('' + exampleCounter).padStart(el.n, '0');
    return result;
  }, '');
};

angular.module('cloudX').directive('cxGeneratedCodeFormat', [
  function() {
    return {
      restrict: 'E',
      template: require('./generatedCodeFormat.html'),
      scope: {
        data: '=',
        submit: '&',
        cancel: '&',
        firstNumber: '=',
        showWarning: '=',
      },
      controller: [
        '$scope',
        '$q',
        function($scope, $q) {
          $scope.editMode = false;
          $scope.elements = [];
          $scope.saving = false;

          $scope.parts = [
            { id: 'Counter', n: 0 },
            { id: 'Text', t: '' },
          ];
          $scope.addPart = function(nr) {
            if (nr !== 0 || !$scope.hasCounter())
              $scope.elements.push(angular.copy($scope.parts[nr]));
          };

          $scope.startEdit = function() {
            $scope.editMode = true;
            $scope.elements = parseGeneratedCodeFormat($scope.data);
          };
          $scope.dragIndex = null;
          $scope.startDrag = function(e, ui, index) {
            $scope.dragIndex = index;
          };
          $scope.stopDrag = function() {
            $scope.dragIndex = null;
          };
          $scope.dragOver = function(e, ui, index) {
            var dropEl = $(e.target);
            dropEl.removeClass('drop-left').removeClass('drop-right');
            if ($scope.dragIndex == null) return;
            if ($scope.dragIndex < index) dropEl.addClass('drop-right');
            if ($scope.dragIndex > index) dropEl.addClass('drop-left');
          };
          $scope.hasCounter = function() {
            return (
              $scope.elements.findIndex(function(el) {
                return el.id === 'Counter';
              }) >= 0
            );
          };

          $scope.example = function() {
            if (!$scope.editMode)
              return generateGeneratedCodeExample($scope.data);
            return generateGeneratedCodeExample($scope.elements);
          };
          $scope.firstNumberExample = function() {
            if (!$scope.editMode)
              return generateGeneratedCodeExample($scope.data, $scope.firstNumber);
            return generateGeneratedCodeExample($scope.elements, $scope.firstNumber);
          };

          $scope.cancelEdit = function() {
            $scope.editMode = false;
            $scope.cancel();
          };
          $scope.clear = function() {
            $scope.elements = [];
          };
          $scope.save = function() {
            var result = $scope.elements.reduce(function(result, el) {
              if (el.id === 'Text') return result + el.t;
              if (el.id === 'Counter') return result + ('[Counter:N' + (el.n || '0') + ']');
              return result;
            }, '');

            $scope.saving = true;
            return $q.when($scope.submit({ newVal: result })).then(
              function(success) {
                $scope.saving = false;
                //Error. Local model will not be updated, form will not close
                if (typeof success === 'string') return;

                //Success. Local model will be updated automatically
                if (typeof success === 'undefined' || !!success) $scope.data = result;

                //Form will close
                $scope.editMode = false;
              },
              error => {
                $scope.saving = false;
              },
            );
          };
        },
      ],
    };
  },
]);

